export const PATH = {
  ABOUT: '/about/',
  POST: '/post/',
  TAG: '/tag/',
};
